import logo from '../media/logo.png';
import './About.css';

function About() {
  return (
    <div className="About">
        <img src={logo} className="App-logo" alt="logo" />   
        <p>
            Xenotech Studio
        </p>
    </div>
  );
}

export default About;
